import { NextImage } from '../../types/CommonVM';
import { DownloadApp } from '../domain/entities/DownloadApp';

const DOWNLOAD_APP_ICON_URL =
  'https://dom-content-vault-prod-cdn-assets.porter.in/download_app_d2ac3cc4d7/download_app_d2ac3cc4d7.svg';

export const download_card_track_order: DownloadApp = {
  text: 'We are better on the app!',
  sub_text: '',
  cta_text: 'Download Now',
  icon: {
    alt_text: 'Download app',
    path: DOWNLOAD_APP_ICON_URL,
  },
};

export const download_app_mobile_menu: NextImage = {
  src: DOWNLOAD_APP_ICON_URL,
  width: 132,
  height: 116.36,
  alt: 'download app',
};
